import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';
import { SaveCanarVenta } from '../../shared/components';

export interface CreateCanalVentaPageInterface {}

const CreateCanalVentaPage: React.FC<CreateCanalVentaPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_add_canalventa);

  return <SaveCanarVenta titlePage="Crear Canal de Venta" />;
};

export default CreateCanalVentaPage;
